import * as TanStackQueryProvider from "@fp/ui/integrations/tanstack-query/root-provider";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import "./lib/axios";
import "./styles.css";
import { BatchProcessProvider } from "./components/batch-process/batch-process-context";
import { DepositToasts } from "./components/funding/deposit-toasts";
import { GoogleMapsConfigProvider } from "./components/google-maps-config";
import { PageActionsProvider } from "./components/page-actions-context";
import { UserContextProvider } from "./components/user-context";
import { SignalRProvider } from "./hooks/useSignalR";
import { loadNewVersionOnNavigation } from "./lib/application-version";
import reportWebVitals from "./reportWebVitals";
import { router } from "./router";

loadNewVersionOnNavigation(router);

async function enableMocking() {
  if (!import.meta.env.DEV || import.meta.env.VITE_ENABLE_MOCKING !== "true") {
    return;
  }

  const { worker } = await import("@fp/mocks/browser.js");

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

// Use the same queryClient that the router uses to avoid cache inconsistencies
const queryClient = router.options.context.queryClient;

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  enableMocking().then(() => {
    root.render(
      <StrictMode>
        <TanStackQueryProvider.Provider queryClient={queryClient}>
          <UserContextProvider router={router}>
            <GoogleMapsConfigProvider>
              <SignalRProvider>
                <DepositToasts />
                <BatchProcessProvider>
                  <PageActionsProvider>
                    <RouterProvider router={router} />
                  </PageActionsProvider>
                </BatchProcessProvider>
              </SignalRProvider>
            </GoogleMapsConfigProvider>
          </UserContextProvider>
        </TanStackQueryProvider.Provider>
      </StrictMode>,
    );
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
